import { useParams } from "react-router-dom";
import { UserForm } from "./components/UserForm";
import { userService } from "@/frontend/services";
import type { UserResponseDTO } from "@/shared/dto";
import { useGetId } from "@/frontend/hooks/useGetId";
import { Spin } from "@/frontend/components/common";

export function UpdateUserPage() {
  const { id } = useParams<{ id: string }>();
  const { data, loading } = useGetId<UserResponseDTO>({
    fetchFn: userService.getById,
    redirectUrl: "/users",
    errorMessage: "Error al cargar el usuario",
    id,
  });

  if (loading) {
    return (
      <div className="bg-white rounded-lg p-6 shadow-sm w-full">
        <div className="flex justify-center items-center py-12">
          <Spin size="large" tip="Cargando usuario..." />
        </div>
      </div>
    );
  }

  if (!data) {
    return null;
  }

  const initialValues = {
    email: data.email,
    username: data.username,
    firstName: data.firstName,
    lastName: data.lastName,
    secondName: data.secondName,
    secondLastName: data.secondLastName,
    phone: data.phone,
    dni: data.dni,
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm w-full">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Actualizar Usuario</h2>
        <p className="text-gray-600 mt-1">
          Modifica la información del usuario en la plataforma
        </p>
      </div>
      <UserForm userId={id} initialValues={initialValues} />
    </div>
  );
}
